import * as Constants from './constants'

export const checkinListRequest = (formData) => {
  return {
    type: Constants.CHECKIN_LIST_REQUESTING,
    payload: formData
  }
}

export const checkinListSuccess = (data) => {
  return {
    type: Constants.CHECKIN_LIST_SUCCESS,
    data
  }
}

export const checkinListError = (error) => {
  return {
    type: Constants.CHECKIN_LIST_ERROR,
    error
  }
}

export const checkinUpdateRequest = (formData, callback) => {
  return {
    type: Constants.CHECKIN_UPDATE_REQUESTING,
    payload: formData,
    callback
  }
}

export const checkinUpdateSuccess = (response) => {
  return {
    type: Constants.CHECKIN_UPDATE_SUCCESS,
    payload: response
  }
}

export const checkinUpdateError = (error) => {
  return {
    type: Constants.CHECKIN_UPDATE_ERROR,
    error
  }
}

export const checkinReportRequest = (formData) => {
  return {
    type: Constants.CHECKIN_REPORT_REQUESTING,
    payload: formData
  }
}

export const checkinReportSuccess = (data) => {
  return {
    type: Constants.CHECKIN_REPORT_SUCCESS,
    data
  }
}

export const checkinReportError = (error) => {
  return {
    type: Constants.CHECKIN_REPORT_ERROR,
    error
  }
}

export const checkinReportNvkdRequest = (formData) => {
  return {
    type: Constants.CHECKIN_REPORT_NVKD_REQUESTING,
    formData
  }
}

export const checkinReportNvkdSuccess = (data) => {
  return {
    type: Constants.CHECKIN_REPORT_NVKD_SUCCESS,
    data
  }
}

export const checkinReportNvkdError = (error) => {
  return {
    type: Constants.CHECKIN_REPORT_NVKD_ERROR,
    error
  }
}

export const checkinReportExportXlsRequest = (formData, callback) => {
  return {
    type: Constants.CHECKIN_REPORT_EXPORT_XLS_REQUESTING,
    formData,
    callback
  }
}

export const checkinReportExportXlsSuccess = (data) => {
  return {
    type: Constants.CHECKIN_REPORT_EXPORT_XLS_SUCCESS,
    data
  }
}

export const checkinReportExportXlsError = (error) => {
  return {
    type: Constants.CHECKIN_REPORT_EXPORT_XLS_ERROR,
    error
  }
}

export const checkinKhachHangRequest = (formData, callback) => {
  return {
    type: Constants.CHECKIN_KHACHHANG_REQUESTING,
    formData,
    callback
  }
}


// WEBPACK FOOTER //
// ./src/views/Checkin/actions.js